import { useEffect, useState } from "react";

export const useOtpTimer = (initialTime = 20) => {
  const [timer, setTimer] = useState(initialTime);
  const [resendEnabled, setResendEnabled] = useState(false);

  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(countdown);
          setResendEnabled(true);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => clearInterval(countdown);
  }, []);

  const resetTimer = () => {
    setTimer(initialTime);
    setResendEnabled(false);
  };

  return { timer, resendEnabled, resetTimer };
};
